import React, { useState, useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import { getCountries } from 'Reducers/Countries/actions'
import { getCities } from 'Reducers/City/actions'
import {
  getDocumentTypeById,
  createDocumentType,
  updateDocumentTypeById,
  deleteDocumentTypeById,
} from 'Reducers/Document/actions'

import { DocumentCreateEditWrapper } from 'Components/Settings/Documentation/DocumentCreateEditWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import DocumentBreadcrumbs from '../DocumentBreadcrumbs/index'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import DocumentForm from '../DocumentForm/index'

import { DOCUMENT_FORM } from '../constants'
import { PATHS } from 'Config/Routing/paths'
import { authorization } from 'Module/Auth/Auth'

import { styles } from '../styles'
import { showReduxModal } from '../../../../Reducers/UI/actions'

const Document = ({
  mode,
  countries,
  documentType,
  getCountries,
  getDocumentTypeById,
  createDocumentType,
  updateDocumentTypeById,
  deleteDocumentTypeById,
}) => {
  const match = useRouteMatch()
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(true)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCities())
    getCountries()
    if (mode === DOCUMENT_FORM.EDIT) {
      const documentId = match.params.id
      getDocumentTypeById(documentId)
    }
    return () => {
      deleteDocumentTypeById()
    }
  }, [])

  useEffect(() => {
    if (mode === DOCUMENT_FORM.CREATE || Object.keys(documentType).length) {
      setIsLoading(false)
    }
  }, [documentType])

  const getCountryCodeSelectOptions = () => {
    const countryCodeOptions = countries.map(country => ({
      label: country.code,
      value: country.code,
    }))

    countryCodeOptions.unshift({
      label: 'Please select',
      value: undefined,
    })

    return countryCodeOptions
  }

  const redirectToDocumentationList = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
        PATHS.settings.documentation
      }`,
    )
  }

  const submitHandler = (values, isValid) => {
    if (!isValid) return
    const { name, countrycode, instructiontext, active, citiesList } = values

    const ignoredCities = citiesList.value
      .filter(city => !city.isActive)
      .map(city => city.value)

    const callbacks = {
      onSuccess: redirectToDocumentationList,
    }

    const getStatus = () => {
      if (mode === DOCUMENT_FORM.CREATE) {
        return citiesList.value.length === ignoredCities.length
      } else {
        return active.value === 'true'
          ? citiesList.value.length === ignoredCities.length
          : false
      }
    }

    if (getStatus()) {
      return dispatch(
        showReduxModal({
          title: 'Validation error',
          children: `Select at least one city to submit the document`,
          confirmLabel: `OK`,
          hideCancel: true,
        }),
      )
    }
    const submitValues = {
      name: name.value,
      label: name.value,
      instruction_title: name.value,
      instruction_text: instructiontext.value,
      country_code: countrycode.value,
      ignored_cities: ignoredCities,
      active: mode === DOCUMENT_FORM.CREATE ? true : active.value,
    }

    if (mode === DOCUMENT_FORM.CREATE) {
      createDocumentType(callbacks, submitValues)
    } else {
      const documentId = match.params.id

      updateDocumentTypeById(callbacks, documentId, submitValues)
    }
  }

  const allCities = useSelector(state => state.city.citiesList)

  const { countryCode } = authorization.getUser()

  return (
    <LayoutDashboard>
      <DocumentCreateEditWrapper>
        <DocumentBreadcrumbs
          currentPath={match.url}
          mode={mode}
          documentName={documentType.name}
        />
        <HideWhenBlocked>
          {isLoading ? (
            <LoadingIndicator />
          ) : (
            <DocumentForm
              submitHandler={submitHandler}
              mode={mode}
              documentType={documentType}
              сountryCodeSelectOptions={getCountryCodeSelectOptions()}
              redirectToDocumentationList={redirectToDocumentationList}
              allCities={allCities}
              countryCode={countryCode}
            />
          )}
        </HideWhenBlocked>
      </DocumentCreateEditWrapper>
    </LayoutDashboard>
  )
}

const mapStateToProps = state => ({
  countries: state.countries.countriesList,
  documentType: state.document.documentTypeById,
})

export default connect(
  mapStateToProps,
  {
    getCountries,
    getDocumentTypeById,
    deleteDocumentTypeById,
    updateDocumentTypeById,
    createDocumentType,
  },
)(withStyles(styles)(Document))
